import { Component, Input, signal, SimpleChanges } from '@angular/core';
import { GetSystemConfigViewModel } from 'edu-application/dist/system-config/get-system-config/get-system-config.veiwmodel';
import { SettingsService } from '../settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PermissionsService } from '../../shared/permissions/permissions.service';
import { PERMISSIONS } from 'edu-core';

@Component({
  selector: 'edu-group-visibility-settings',
  standalone: false,
  templateUrl: './group-visibility-settings.component.html',
  styleUrl: './group-visibility-settings.component.scss',
})
export class GroupVisibilitySettingsComponent {
  @Input() orgId!: string;
  @Input() systemConfig: GetSystemConfigViewModel | null = null;

  enabled = signal(false);
  isSaving = signal(false);

  constructor(
    private settingsService: SettingsService,
    private snackBar: MatSnackBar,
    private permissions: PermissionsService,
  ) {}

  /** Writing these settings requires organization-settings.manage. */
  get canManage(): boolean {
    return this.permissions.has(PERMISSIONS.organizationSettings.manage);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['systemConfig'] && this.systemConfig) {
      this.enabled.set(this.systemConfig.allowAllGroupsVisible);
    }
  }

  toggle(): void {
    if (!this.canManage || this.isSaving()) {
      return;
    }
    const next = !this.enabled();
    this.enabled.set(next);
    this.isSaving.set(true);
    this.settingsService.setGroupVisibility(this.orgId, next).subscribe({
      next: () => {
        this.snackBar.open('✅ Group visibility updated', 'Dismiss', {
          duration: 3000,
        });
        this.isSaving.set(false);
      },
      error: () => {
        this.enabled.set(!next); // revert on failure
        this.snackBar.open('❌ Failed to update group visibility', 'Dismiss', {
          duration: 3000,
        });
        this.isSaving.set(false);
      },
    });
  }
}
